// PIN lock helpers — stored ONLY in localStorage, SHA-256 hashed so the plain
// PIN never touches disk or network. Each user device keeps its own PIN.
const KEY_HASH = "pk2_pin_hash";
const KEY_LEN = "pk2_pin_len";

export async function hashPin(pin) {
  const buf = new TextEncoder().encode(pin);
  const digest = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function isPinEnabled() {
  return !!localStorage.getItem(KEY_HASH);
}

export function getPinHash() {
  return localStorage.getItem(KEY_HASH);
}

export async function setPinHash(pin) {
  const hash = await hashPin(pin);
  localStorage.setItem(KEY_HASH, hash);
  localStorage.setItem(KEY_LEN, String(pin.length));
  localStorage.setItem("pk2_pin_fails", "0");
  localStorage.removeItem("pk2_pin_locked_until");
  return hash;
}

export function clearPin() {
  localStorage.removeItem(KEY_HASH);
  localStorage.removeItem(KEY_LEN);
  localStorage.removeItem("pk2_pin_fails");
  localStorage.removeItem("pk2_pin_locked_until");
}
